import { SVG } from "shared";
import "./Contact.scss";
import ContactForm from "./ContactForm";
import { SVG_ENUM, HOME_SCROLL_ENUM } from "enums";
import { isDesktop } from "utils";

type ContactProps = {};

const Contact: React.FC<ContactProps> = () => {
  return (
    <div className="contact">
      {isDesktop() && (
        <SVG type={SVG_ENUM.LOGIN_BG_DESKTOP} className="contact__bg" />
      )}
      <div className="layout" id={HOME_SCROLL_ENUM.CONTACT}>
        <div className="contact__left">
          <h2>Pozostańmy w&nbsp;kontakcie</h2>
          <p>
            Zapraszamy do kontaktu za pośrednictwem formularza. Zespół Reliance
            odpowie na Państwa wiadomość tak szybko, jak to możliwe.
          </p>
          <div className="contact__lines">
            <div className="contact__line">
              <SVG type={SVG_ENUM.CLOCK} className="contact__icon" />
              <p>Pon - Pt&nbsp;&nbsp;&nbsp;8:00-16:00</p>
            </div>
            <div className="contact__line">
              <SVG type={SVG_ENUM.PHONE} className="contact__icon" />
              <p>
                <a
                  href="tel:+48123450744"
                  aria-label="Zadzwoń: +48 12 345 07 44"
                >
                  +48 12 345 07 44
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="contact__right">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
